export enum EventCode {
  GRAPHQL_ERROR_EVENT = 'graphql_error',
  NETWORK_ERROR_EVENT = 'network_error',
  STORAGE_CHANGE_EVENT = 'storage',
}
